import React from 'react';
import ProfileLayout from '../../../layout/profile';
import ClientDevice from './ClientDevice';

export default function Device () {
    return (
        <ProfileLayout>
            <ClientDevice />
        </ProfileLayout>
    );
}
